import { memo } from 'react';

export interface IImageLayout {
  className?: string;
  quick?: boolean;
  alt: string;
  link: { url: string; height?: number; width?: number }[];
}

export const ImageLayout = memo(function ImageLayout(props: IImageLayout) {
  const { className, quick, alt, link } = props;

  const sizes = link
    .filter((e) => e.width !== undefined)
    .map((e) => {
      return `${e.url} ${e.width}w`;
    })
    .join(', ');

  let biggest = link[0];

  if (link.length > 1) {
    biggest = link
      .filter((e) => e.width !== undefined)
      .sort((a, b) => a.width! - b.width!)[0];
  }

  return (
    <img
      alt={alt}
      loading={quick ? 'eager' : 'lazy'}
      className={className}
      srcSet={sizes}
      src={biggest.url}
      width={biggest.width}
      height={biggest.height}
    ></img>
  );
});
